export default __webpack_public_path__ + "static/tourLen-d22d901e71cc4e572a653f43b3995cc7.svg";